import {
  AfterViewInit,
  Component,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { BrowserStorageService } from '@shared/services/browser-storage.service';
import { CookiePrefence } from '@shared/models/cookie-preference.model';
import { ModalService } from '@shared/services/modal.service';
import { convertObjToCookieValue } from '@shared/utils/cookie-util';
import { CookieKeyEnum } from '@shared/enums/cookie-key.enum';
import { GoogleAnalyticsService } from '@shared/services/google-analytics.service';

@Component({
  selector: 'app-cookie-consent',
  imports: [CommonModule, MatButtonModule],
  templateUrl: './cookie-consent.component.html',
  styleUrls: ['./cookie-consent.component.scss'],
})
export class CookieConsentComponent implements AfterViewInit {
  constructor(
    private browserStorageService: BrowserStorageService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private modalService: ModalService,
  ) {}

  @ViewChild('cookieDialogActions') cookieDialogActions!: TemplateRef<Element>;

  ngAfterViewInit() {
    this.modalService.setModalFooterActions(this.cookieDialogActions);
  }

  acceptAllCookies() {
    const cookiePrefence: CookiePrefence = {
      necessary: true,
      analytics: true,
      advertisement: true,
      functionality: true,
    };
    this.browserStorageService.setCookie(
      CookieKeyEnum.COOKIE_PREFERENCE,
      convertObjToCookieValue(cookiePrefence),
    );
    this.browserStorageService.setCookie(
      CookieKeyEnum.GOOGLE_ANALYTICS_CONSENT_GRANTED,
      true,
    );
    this.googleAnalyticsService.grantAnalyticsConsent();
    this.modalService.close();
  }

  declineAllCookies() {
    const cookiePrefence: CookiePrefence = {
      necessary: false,
      analytics: false,
      advertisement: false,
      functionality: false,
    };
    this.browserStorageService.setCookie(
      CookieKeyEnum.COOKIE_PREFERENCE,
      convertObjToCookieValue(cookiePrefence),
    );

    this.modalService.close();
  }
}
